import React, {Suspense} from "react";
import {Await, defer, json, useLoaderData} from "react-router-dom";
import {TemplateWithoutBody} from "../../model/Template";
import {CircularProgress} from "@mui/material";
import {getCustomerTemplatesForAdmins} from "../../api/templateClient";
import {getDemoConfig} from "../../api/demoConfigClient";
import {DemoConfigEditor} from "../../components/Customer/DemoConfigEditor";

const DemoConfigPage: React.FC = (props) => {
    const {templates, demoConfig} = useLoaderData() as {
        templates: TemplateWithoutBody[],
        demoConfig: { demoTemplateIds?: string[], courseUrl?: string, courseName?: string }
    };

    return (
        <Suspense fallback={<CircularProgress/>}>
            <Await resolve={Promise.all([templates, demoConfig])}>
                {data => <DemoConfigEditor 
                    templates={data[0]} 
                    demoTemplateIds={data[1]?.demoTemplateIds || []}
                    courseUrl={data[1]?.courseUrl}
                    courseName={data[1]?.courseName}
                />}
            </Await>
        </Suspense>
    )
}

export default DemoConfigPage;

export async function loadTemplates(customerId: string) {
    try {
        return await getCustomerTemplatesForAdmins(customerId);
    } catch (error) {
        throw json({message: 'Could not fetch templates.'}, {status: 500});
    }
}

export async function loadDemoConfig(customerId: string) {
    try {
        const demoConfig = await getDemoConfig(customerId);
        return demoConfig;
    } catch (error) {
        // If customer is not a demo customer, return empty config
        return { demoTemplateIds: [], courseUrl: undefined, courseName: undefined };
    }
}

export async function loader({
                                 request,
                                 params
                             }: { request: Request, params: { customerId: string } }) {
    const customerId = params.customerId;

    return defer({
        templates: loadTemplates(customerId),
        demoConfig: loadDemoConfig(customerId),
    })
}